import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeAdministracaoConsultaBensImoveis: [],
    removeClassificacaoConsultaBensImoveis: [],
    removeCodigoSituacaoLegalConsultaBensImoveis: [],
    removeIdentificacaoConsultaBensImoveis: [],
    removeEnderecoConsultaBensImoveis: [],
    removeStatusConsultaBensImoveis: [],
    setMostraAplicarFiltroConsultaBensImoveis: [],
    limpaFiltroConsultaBensImoveis: [],
    aplicarFiltroConsultaBensImoveis: ['filtro'],
})

const INITIAL_STATE = {
    administracao: [],
    classificacao: [],
    codigoSituacaoLegal: [],
    identificacao: '',
    endereco: '',
    status: '',
    mostraAplicarFiltro: false,
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracao.splice(state.administracao.indexOf(action.administracao), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.administracao = Array.from(state.administracao)
    return { ...state, mostraAplicarFiltro: true }
}

const removeClassificacao = (state = INITIAL_STATE, action) => {
    state.classificacao.splice(state.classificacao.indexOf(action.classificacao), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.classificacao = Array.from(state.classificacao)
    return { ...state, mostraAplicarFiltro: true }
}

const removeCodigoSituacaoLegal = (state = INITIAL_STATE, action) => {
    state.codigoSituacaoLegal.splice(state.codigoSituacaoLegal.indexOf(action.codigoSituacaoLegal), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.codigoSituacaoLegal = Array.from(state.codigoSituacaoLegal)
    return { ...state, mostraAplicarFiltro: true }
}

const removeIdentificacacao = (state = INITIAL_STATE, action) => {
    return { ...state, identificacao: '', mostraAplicarFiltro: true }
}

const removeEndereco = (state = INITIAL_STATE, action) => {
    return { ...state, endereco: '', mostraAplicarFiltro: true }
}

const removeStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: '', mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_BENS_IMOVEIS]: removeAdministracao,
    [Types.REMOVE_CLASSIFICACAO_CONSULTA_BENS_IMOVEIS]: removeClassificacao,
    [Types.REMOVE_CODIGO_SITUACAO_LEGAL_CONSULTA_BENS_IMOVEIS]: removeCodigoSituacaoLegal,
    [Types.REMOVE_IDENTIFICACAO_CONSULTA_BENS_IMOVEIS]: removeIdentificacacao,
    [Types.REMOVE_ENDERECO_CONSULTA_BENS_IMOVEIS]: removeEndereco,
    [Types.REMOVE_STATUS_CONSULTA_BENS_IMOVEIS]: removeStatus,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_BENS_IMOVEIS]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_CONSULTA_BENS_IMOVEIS]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_BENS_IMOVEIS]: aplicarFiltro,
})
